import { getRecommendationId } from "../context/recommendationContext";
import { isPreviewMode } from "./previewUtils";

/**
 * Baut Legal-Link-URL mit Recommendation-ID und optional preview=true
 */
export function buildLegalLink(originalUrl: string): string {
    const url = new URL(originalUrl, window.location.origin);

    const recommendationId = getRecommendationId();
    if (recommendationId && !url.searchParams.has("id")) {
        url.searchParams.append("id", recommendationId);
    }

    if (isPreviewMode() && !url.searchParams.has("preview")) {
        url.searchParams.append("preview", "true");
    }

    return url.pathname + url.search;
}
